// constants.jsx
// Systemwide constants for Rent Utopia frontend

//Test env
/*export const API_CONSTANTS = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:9080/api',
    ENDPOINTS: {
        USER_TYPES: '/user-types',
        LOGIN: 'auth/login',
    },
};*/
// .github/workflows/deploy.yml

export const API_CONSTANTS = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://svr.pegasus-pms.co.ke/utopia/api',
    ENDPOINTS: {
        USER_TYPES: '/user-types',
        LOGIN: 'auth/login',
    },
};

export const USER_TYPES = {
    PROSPECTIVE_TENANT: {
        id: 'prospective_tenant',
        label: 'Prospective Tenant',
        description: 'Looking for a property to rent',
        icon: 'User',
        color: 'blue',
    },
    PROPERTY_SEEKER: {
        id: 'property_seeker',
        label: 'Property Seeker',
        description: 'Searching for properties to buy or rent',
        icon: 'User',
        color: 'cyan',
    },
    REAL_ESTATE_AGENT: {
        id: 'real_estate_agent',
        label: 'Real Estate Agent',
        description: 'Managing property listings and clients',
        icon: 'Building',
        color: 'green',
    },
    SYSTEM_ADMIN: {
        id: 'system_admin',
        label: 'System Admin',
        description: 'Platform administration and maintenance',
        icon: 'Shield',
        color: 'purple',
    },
};

export const UI_CONSTANTS = {
    DEFAULT_TIMEOUT: 5000, // ms
    COLORS: {
        PRIMARY: '#2c3e50',
        SECONDARY: '#3498db',
        ERROR: '#e74c3c',
        SUCCESS: '#2ecc71',
        WARNING: '#f1c40f',
    },
    BREAKPOINTS: {
        MOBILE: '640px',
        TABLET: '768px',
        DESKTOP: '1024px',
    },
};

export const APP_CONSTANTS = {
    APP_NAME: 'Rent Utopia',
    VERSION: '1.0.0',
    DEFAULT_PAGE_SIZE: 10,
    MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB in bytes
};